import React from "react"

var a = [
  "",
  "one ",
  "two ",
  "three ",
  "four ",
  "five ",
  "six ",
  "seven ",
  "eight ",
  "nine ",
  "ten ",
  "eleven ",
  "twelve ",
  "thirteen ",
  "fourteen ",
  "fifteen ",
  "sixteen ",
  "seventeen ",
  "eighteen ",
  "nineteen "
]
var b = [
  "",
  "",
  "twenty",
  "thirty",
  "forty",
  "fifty",
  "sixty",
  "seventy",
  "eighty",
  "ninety"
]

function inWords(num) {
  if ((num = num.toString()).length > 9) return "overflow"
  const n = ("000000000" + num)
    .substr(-9)
    .match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/)
  if (!n) return
  let str = ""
  str +=
    parseInt(n[1]) !== 0
      ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + "billion "
      : ""
  str +=
    parseInt(n[2]) !== 0
      ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + "million "
      : ""
  str +=
    parseInt(n[3]) !== 0
      ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + "thousand "
      : ""
  str +=
    parseInt(n[4]) !== 0
      ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + "hundred "
      : ""
  str +=
    parseInt(n[5]) !== 0
      ? (str !== "" ? "and " : "") +
        (a[Number(n[5])] || b[n[5][0]] + " " + a[n[5][1]])
      : ""
  return str
}

export default function({ daysLeft, isPaid, children }) {
  return (
    <div className="order-display">
      <div className="order-title">
        <h2>YOUR ORDER HAS BEEN {isPaid ? "CONFIRMED" : "RECEIVED"}</h2>
        {(isPaid && <p>Thank you for your purchase!</p>) || (
          <p>
            {`Please make sure you submit your proof of payment within ${inWords(
              daysLeft
            )} (${daysLeft}) ${
              daysLeft > 1 ? "days" : "day"
            }, otherwise the order will be cancelled.`}
          </p>
        )}
      </div>
      <div className="order-data">{children}</div>
    </div>
  )
}
